import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'

import { useQuery } from '~/client/hooks/cqrpc'
import Heading from '~/client/components/Heading'
import SideNote from '~/client/components/SideNote'
import EventsList from '~/client/components/EventsList'

export const routeOptions = {
  mustBeUser: true
}

export default function EventsPage() {
  return <Container>
    <Heading my={2} variant="main">Accounts</Heading>
    <SideNote>
      Everything that happens under your DataPal account has an
      initiating event so you know who, what and how it happened.
    </SideNote>
    <MyEvents/>
  </Container>
}

function MyEvents(){
  const { result: events = [], loading, error } = useQuery('events.getMine')
  return <EventsList {...{loading, error, events}}/>
}
